(function (window, document, $, undefined) {

	$(function () {

		/**
		 * Simple Generic Carousel
		 */

		$('.js-simple-gallery').each(function () {

			var $slider = $('.js-simple-gallery-track', $(this));
			var $next = $('.js-simple-gallery-next', $(this));
			var $prev = $('.js-simple-gallery-prev', $(this));

			$slider.slick({
				dots: false,
				arrows: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
			});

			$prev.on('click', function (ev) {
				ev.preventDefault();

				$slider.slick('slickPrev');
			});

			$next.on('click', function (ev) {
				ev.preventDefault();

				$slider.slick('slickNext');
			});

		});

		/**
		 * Image Gallery Carousel
		 */

		$('.jsImageGalleryCarouselWrapper').each(function () {

			var $wrapper = $(this);
			var $slider1 = $wrapper.find('.jsImageGalleryMainCarousel');
			var $slider2 = $wrapper.find('.jsImageGalleryMiniCarousel');

			$slider1.slick({
				dots: false,
				arrows: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				asNavFor: $slider2,
			});

			$slider2.slick({
				dots: false,
				arrows: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				asNavFor: $slider1,
				focusOnSelect: true,
				centerMode: true,
				centerPadding: '35%',
			});

		});

		/**
		 * Partners Carousel
		 */

		$('.jsPartnerCarouselWrapper').each(function () {

			var $wrapper = $(this);
			var $slider1 = $wrapper.find('.jsPartnerImageCarousel');
			var $slider2 = $wrapper.find('.jsPartnerContentCarousel');
			var $nav = $wrapper.find('.jsPartnerCarouselNav');

			$slider1.slick({
				dots: false,
				arrows: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				fade: true,
				cssEase: 'linear',
				speed: 500,
				swipe: false
			});

			$slider2.slick({
				dots: false,
				arrows: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				fade: true,
				cssEase: 'linear',
				speed: 500,
				swipe: false
			});

			$nav.on('click', function (e) {
				e.preventDefault();

				$slider1.slick($(this).data('dir'));
				$slider2.slick($(this).data('dir'));
			});

		});

		/**
		 * Members Carousels
		 */
		$('.jsMembersSection').each(function () {

			var $wrapper = $(this);
			var $mainSlider = $wrapper.find('.jsMembersCarousel');
			var $sideSlider = $wrapper.find('.jsMembersSingleCarousel');
			var $nav = $wrapper.find('.jsMembersCarouselNav');

			$mainSlider.slick({
				dots: false,
				arrows: false,
				slidesToShow: 3,
				slidesToScroll: 1,
				infinite: true,
				swipe: false,
				draggable: false,
				responsive: [
					{
						breakpoint: 1680,
						settings: {
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
						}
					}
				]
			});

			$sideSlider.slick({
				dots: false,
				arrows: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				swipe: false,
				draggable: false,
				fade: true
			});

			$mainSlider.slick('slickNext');

			$nav.on('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				$mainSlider.slick($(this).data('dir'));
				$sideSlider.slick($(this).data('dir'));
			});

		});

		$('.jsTestimonialsBoxWrapper').each(function () {

			var $wrapper = $(this);
			var $mainSlider = $wrapper.find('.jsMainTCarousel');
			var $sideSlider = $wrapper.find('.jsSideTCarousel');
			var $nav = $wrapper.find('.jsCarouselNav');

			$mainSlider.slick({
				dots: false,
				arrows: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				swipe: false,
				draggable: false,
			});

			$sideSlider.slick({
				dots: false,
				arrows: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				swipe: false,
				draggable: false,
				fade: true
			});

			$nav.on('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				$mainSlider.slick($(this).data('dir'));
				$sideSlider.slick($(this).data('dir'));
			});

		});

		$(document).on('click', function (e) {
			if ($(e.target).closest('.jsJumpNavigationDList').length === 0 && $(e.target).closest('.jsJumpNavigationDCaption').length === 0) {
				$('.jsJumpNavigationDList').removeClass('is_active');
			}
		});

		$('.jsJumpNavigationDCaption').on('click', function () {
			$('.jsJumpNavigationDList').toggleClass('is_active');
		});

		$('.jsJumpNavigationDLink').on('click', function (e) {
			$('.jsJumpNavigationDCaption').text($(this).text());
			$('.jsJumpNavigationDList').removeClass('is_active');
		});

		$('.jsJumpNavigationDClose').on('click', function () {
			$('.jsJumpNavigationDList').removeClass('is_active');
		});

		$('.jsStickyBookmarks').each(function () {

			var $this = $(this);

			setTimeout(function () {
				$this.stick_in_parent({
					parent: 'body',
					offset_top: get_jump_navigation_offset_top(),
					//recalc_every: 5
				}).on('sticky_kit:stick', function (e) {
					$(e.target).css({
						top: get_jump_navigation_offset_top() + 'px'
					});
				});
			}, 500);

		});

		/**
		 * Bookmarks
		 */
		if ($('.page-bookmarks').length > 0) {

			function highlightMenuitem(id) {
				if ($(`.bookmark-links a[href="#${id}"]`).length > 0) {
					$('.bookmark-links a').removeClass('is_active');
					$(`.bookmark-links a[href="#${id}"]`).addClass('is_active');
					$('.jsJumpNavigationDList a').removeClass('is_active');
					$(`.jsJumpNavigationDList a[href="#${id}"]`).addClass('is_active');
					$('.jsBookmarksCaption').text($(`.bookmark-links a[href="#${id}"]`).text());
				}
			}

			$('section, .section-anchorpoint').each(function () {
				$(this).waypoint({
					handler: function (dir) {
						if (dir === 'down') {
							highlightMenuitem(this.element.id);
						}
					}, offset: '100px'
				});
				$(this).waypoint({
					handler: function (dir) {
						if (dir === 'up') {
							highlightMenuitem(this.element.id);
						}
					}, offset: '-50%'
				});
			});

		}

		/**
		 * Anchor links
		 */
		$('a[href^=\\#]').on('click', function (e) {
			e.preventDefault();

			var $elem = $($.attr(this, 'href'));
			if ($elem.length > 0) {
				$('html, body').animate({
					scrollTop: $elem.offset().top
				}, 700);
			} else if ($.attr(this, 'href') == '#to-top') {
				$('html, body').animate({ scrollTop: 0 }, 700);
			}
		});

		/**
		 * FAQ row expand
		 */
		$('.jsFAQHead').on('click', function (e) {
			e.preventDefault();

			$(this).find('.jsFAQTitle').toggleClass('is_active');
			$(this).parent().closest('.jsFAQRow').find('.jsFAQClose').toggleClass('is_active');
			$(this).parent().closest('.jsFAQRow').find('.jsFAQContent').slideToggle();
		});

		$('.jsSiteHeaderSearchTrigger').on('click', function (e) {
			e.preventDefault();
			$('.jsSiteHeaderSearchForm').toggleClass('--is-visible');
		});

		$('.jsOffcanvasMenuToggler').on('click', function (e) {
			e.preventDefault();
			$('.jsOffcanvasMenu').toggleClass('is_active');
			$('body').toggleClass('is_open', $('.jsOffcanvasMenu').hasClass('is_active'));
			$('.offcanvas-menu__nav .sub-menu').slideUp();
			$('.offcanvas-menu__nav .expand-btn').removeClass('is_open');
		});

		$('.offcanvas-menu__nav .expand-btn').on('click', function (e) {
			e.preventDefault();
			$(this).parent().parent().find('.sub-menu').slideToggle();
			$(this).toggleClass('is_open');
		});

		/**
		 * Stats counter animation
		 */
		$('[data-stat]').each(function () {

			var done = false;
			var $this = $(this);
			var int = Number.isInteger(Number($this.attr('data-value')));

			$this.waypoint(function (direction) {

				if (!done) {
					done = true;
					$this.prop('Counter', 0).animate({ Counter: $this.attr('data-value') }, {
						duration: 2000,
						easing: 'swing',
						step: function (now) {
							$this.text(int ? Math.ceil(now) : this.Counter.toFixed(1));
						}
					});
				}

			}, { offset: '75%' });

		});

		render_gform_consent_fields();
		jQuery(document).bind('gform_post_render', function () {
			render_gform_consent_fields();
		});

		(new Headroom(document.querySelector('.site-header'))).init();

		/**
		 * Pad the main content instead of putting a spacer in it.
		 */
		function padForHeader() {
			var header = $('.js-header');
			var thingToPad = $('.js-pad');

			if ($('.tribe-common').length) {
				var thingToPad = $('.tribe-common');
			}

			if ($('.tribe-events-pg-template').length) {
				var thingToPad = $('.tribe-events-pg-template');
			}

			thingToPad.css('padding-top', (header.outerHeight() + 20) + 'px');
		}

		padForHeader();

		$(window).on('resize', function () {
			padForHeader();
		});

	});

	function render_gform_consent_fields() {

		$('.gform_wrapper').each(function () {

			var $form = $(this).find('form');
			var $consent = $form.find('.gform_body .gfield.consent');
			var $footer = $form.find('.gform_footer');

			if ($consent.length > 0) {
				$consent.wrapAll('<ul class="consent-gfields"></ul>');
				$form.find('.consent-gfields').prependTo($footer);
			}

		});

	}

	function get_jump_navigation_offset_top() {

		var headerMaxHeight = Math.min($('.site-header').outerHeight(), 136);

		if ($('body').hasClass('admin-bar')) {
			if ($('#wpadminbar').css('position') === 'fixed') {
				return headerMaxHeight + $('#wpadminbar').outerHeight();
			}
		}

		return headerMaxHeight;

	}

})(window, document, jQuery);
